import { Component } from '@angular/core';

@Component({
  templateUrl: './buttons.html'  
})
export class ButtonsComponent { 
    IsExpanded:boolean;

    constructor() { }

    OnClick() {
      console.log("Button Click!");
    }
    
    get ButtonCode() {
      return "<pm-button></pm-button>";
    }
    
    get ButtonBlockCode() {
      return "<pm-button-block></pm-button-block>";
    }
    
    get ButtonIconCode() {
      return "<pm-button-icon></pm-button-icon>";
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/buttons/buttons-component.ts